export { RequestMethod } from '@withtyped/shared';
